import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "../App";
import { RoleGuard } from "../App";
import { StandardURL } from "../App";


const UpdateWaterUnitsPage = () => {
  const navigate = useNavigate();
  const [newAmount, setNewAmount] = useState("");

  const handleUpdateWaterUnits = () => {
    const waterUnitsData = JSON.parse(localStorage.getItem("waterUnits"));
    const waterUnitsId = waterUnitsData.water_unit_id;
    const token = localStorage.getItem("token");

    // Create an object containing the amount
    const requestBody = {
      amount: newAmount,
    };

    // Send a PATCH request to update water units using axios
    axios
      .patch(
        `${StandardURL}/iNyumba/waterunits/updatewaterunits/${waterUnitsId}`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json", // Set content type to application/json
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success(response.data.response);
        navigate(-1);
      })
      .catch((error) => {
        toast.error(error.response.data.response);
        console.error("Error updating water units:", error);
      });
  };

  const handleNewAmountChange = (e) => {
    // Update the newAmount state with the value from the input field
    setNewAmount(e.target.value);
  };

  const handleBack = () => {
    navigate(-1); // Navigates back to the previous page in history
  };

   return (
    <RoleGuard>
      <AuthGuard>
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-2xl border border-gray-200">
            <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center">
              Update Water Units 💧
            </h1>
            <hr className="my-6 border-gray-200" />

            <div className="mb-6">
              <label htmlFor="newAmount" className="block text-sm font-medium text-gray-700 mb-2">
                New Amount:
              </label>
              <input
                type="number"
                id="newAmount"
                className="w-full border border-gray-300 rounded-md py-2 px-3 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                value={newAmount}
                onChange={handleNewAmountChange} // Update the newAmount state when input changes
                placeholder="Enter new water amount"
              />
            </div>

            <div className="flex flex-col sm:flex-row justify-between gap-4">
              <button
                onClick={handleUpdateWaterUnits}
                className="flex-1 sm:flex-none px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-300 ease-in-out"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2 inline-block"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                  <path
                    fillRule="evenodd"
                    d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                    clipRule="evenodd"
                  />
                </svg>
                Update Water Units
              </button>

              <button
                onClick={handleBack}
                className="flex-1 sm:flex-none px-6 py-3 bg-gray-500 text-white font-semibold rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition duration-300 ease-in-out"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2 inline-block"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Back
              </button>
            </div>
          </div>
        </div>
      </AuthGuard>
    </RoleGuard>
  );
};

export default UpdateWaterUnitsPage;
